import { useState } from "react";
import { supabase } from "../../lib/supabase";
import { toast } from "sonner";

// Araç/blog görseli yükleme: Supabase Storage 'vehicle-photos' bucket'ına
// giriş yapmış admin kullanıcının kendi klasörüne yükler (RLS politikası).
export function ImageField({ value, onChange, userId, testid }) {
  const [uploading, setUploading] = useState(false);
  const [broken, setBroken] = useState(false);

  async function upload(e) {
    const file = e.target.files?.[0];
    if (!file || !userId) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      toast.error("Yalnızca JPG, PNG veya WebP yükleyebilirsiniz.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Maksimum dosya boyutu 5 MB.");
      return;
    }
    setUploading(true);
    const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "-");
    const path = `${userId}/${crypto.randomUUID()}-${safeName}`;
    const { error } = await supabase.storage
      .from("vehicle-photos")
      .upload(path, file, { cacheControl: "3600", upsert: false, contentType: file.type });
    setUploading(false);
    if (error) {
      toast.error(`Yükleme başarısız: ${error.message}`);
      return;
    }
    const { data } = supabase.storage.from("vehicle-photos").getPublicUrl(path);
    onChange(data.publicUrl);
    toast.success("Görsel yüklendi.");
  }

  return (
    <div className="space-y-2">
      {value && (
        <img
          src={value}
          alt="Önizleme"
          className="w-full h-36 object-cover rounded border border-white/10"
          data-testid={`${testid}-preview`}
          onError={() => setBroken(true)}
          onLoad={() => setBroken(false)}
        />
      )}
      {value && broken && (
        <p className="text-xs text-red-600 leading-relaxed" data-testid={`${testid}-broken`}>
          Bu bağlantı bir görsel değil ya da açılamıyor. Fotoğrafı bilgisayarınıza indirip
          "Yükle" butonuyla ekleyin. (Paylaşım sayfası bağlantıları, örn. chatgpt.com/s/…, çalışmaz.)
        </p>
      )}
      <div className="flex gap-2">
        <input
          type="text"
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Görsel URL'si"
          data-testid={`${testid}-url-input`}
          className="flex-1 bg-[#0a0e14] border border-white/10 rounded px-3 py-2 text-xs text-white focus:outline-none focus:border-[#f59e0b]"
        />
        <label
          className={`px-3 py-2 rounded text-xs font-bold uppercase tracking-wider cursor-pointer transition-colors ${
            uploading
              ? "bg-slate-700 text-slate-400"
              : "bg-[#f59e0b] text-black hover:bg-white"
          }`}
          data-testid={`${testid}-upload-button`}
        >
          {uploading ? "..." : "Yükle"}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="hidden"
            onChange={upload}
            disabled={uploading || !userId}
          />
        </label>
      </div>
    </div>
  );
}
